import styled from 'styled-components';

export const Iframe = styled('iframe')`
  inset: 0px;
  z-index: 1000;
  display: block;
  border-width: 0px;
  overflow: hidden auto;
`;

export const Image = styled('img')`
  border-radius: ${({ theme }) => theme.x0_5}px;
`;

export const ImageButton = styled.button`
  border: none;
  background: none;
`;
